import { useCallback, useEffect, useState } from 'react'
import { noop } from 'lodash'
import { CustomAgTable, TableColumnType } from '@ui-kit'
import { PersistTablePropsType } from '../types/table.types'
import { updateTableColumns, useDispatch } from '@app-store'

const PersistTable = <T,>({
  tableName = '',
  columns = [],
  data = [],
  actions = [],
  onRowClick = noop,
  onColumnClick = noop,
  onActionClick = noop,
  onSortClick = noop,
  // onColumnListUpdate = noop,
  isColumnChooser = false,
  headerValues,
  isPersistColumns = true,
  sort,
  disabledKey,
  emptyDataMessage = '',
  noBackgroundHover = false,
  maxHeight,
  dataQaId = '',
  minHeight = '',
  ...rest
}: PersistTablePropsType<T>) => {
  const [tableCol, setTableCol] = useState<TableColumnType<T>[]>([])
  const dispatch = useDispatch()

  const handleColumnListUpdate = useCallback(
    (updatedColumns: TableColumnType<T>[]) => {
      setTableCol([...updatedColumns])
      if (isPersistColumns) {
        dispatch(
          updateTableColumns({
            tableName,
            tableColumns: JSON.stringify(updatedColumns),
          })
        )
      }
    },
    [tableName, dispatch, isPersistColumns]
  )
  useEffect(() => {
    setTableCol([...columns])
  }, [columns])

  useEffect(() => {
    if (!isPersistColumns) setTableCol([...columns])
  }, [columns, isPersistColumns])

  useEffect(() => {
    if (!isPersistColumns) return

    dispatch(
      updateTableColumns({
        tableName,
        tableColumns: JSON.stringify(columns),
      })
    )
  }, [])
  return (
    <CustomAgTable<T>
      dataQaId={dataQaId}
      tableName={tableName}
      key={tableName}
      columns={tableCol}
      data={data}
      actions={actions}
      onRowClick={onRowClick}
      onColumnClick={onColumnClick}
      onActionClick={onActionClick}
      onSortClick={onSortClick}
      pageName="persist-table"
      onColumnListUpdate={handleColumnListUpdate}
      isColumnChooser={isColumnChooser}
      headerValues={headerValues}
      sort={sort}
      disabledKey={disabledKey}
      emptyDataMessage={emptyDataMessage}
      noBackgroundHover={noBackgroundHover}
      maxHeight={maxHeight}
      defaultColumns={columns}
      minHeight={minHeight}
      {...rest}
    />
  )
}

export default PersistTable
